import createPromise from "helpers/createPromise";
import TCFdeleteLocalTCString from "../TCFdeleteLocalTCString";
import { IBulkConfig } from "types/config-files/mainConfig";

const resetTCFConsent = (bulkConfig: IBulkConfig): Promise<void> => {
  return createPromise(() => {
    // TODO: HANDLE BULK (check file git history)
    TCFdeleteLocalTCString(bulkConfig);
  });
};

export default resetTCFConsent;
